import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'

import translationsEn from './locale/en'
import translationsUk from './locale/uk'

Vue.use(Vuex)

const mutations = {
  setLanguage(state, lang) {
    state.curLanguage = lang;
  }
};

let state = {
  currLanguage: 'en',
  languages: ['uk', 'en'],
  errors: {
    email_busy: 'This email is already in use, Please, take another email.',
    wrong_json: 'json hasnt needed fields',
    short_password: 'password has less then 8 numbers',
    googleapi400: 'bad request to google api',
    bad_google_token: 'bad google token while google auth',
    no_username: 'authentification hasnt user',
    no_user: 'users email cant be found in db',
    google_user: 'user logged in only via google',
    purepurr_user: 'user already has password',
    wrong_password: 'Your current pasword is wrong, please try one more time.',
    glasses_status: 'This serial number of VR is not available for users',
    glasses_busy: 'This serial number of VR is already in use! Please, check the number',
    no_glasses: 'This serial number of VR doesn\'t exist in our system.Please, check the serial number',
    no_link: 'link cant be found in db',
    link_expired: 'link expired',
    invalid_auth_data: 'This user doesn\'t exist. Please, check your credentials',
    JWTDecodeException: 'cant decode link',
    AddressException: 'not valid email',
    MessagingException: 'error while sending email',
    JSONException: 'cant process string to json',
    SignatureVerificationException: 'cant check link singnature',
    "Invalid promocode": 'This promocode is not valid'
  }
};

let getters = {
  errorsList: state => {
    return state.errors
  },
  translateEnList: state => {
    return state.translationsEn
  },
  translateUkList: state => {
    return state.translationsUk
  },
  getCurrentLanguage: state => {
    return state.currLanguage
  },
  getLangList: state => {
    return state.languages
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  getters
});

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', translationsEn);
Vue.i18n.add('uk', translationsUk);
Vue.i18n.set(localStorage.getItem("currentLang") ? localStorage.getItem("currentLang") : 'eu')

export default store;